import _ from 'lodash'
import { LOGGING_IN, LOGIN_SUCCESSFUL, LOGIN_FAILED } from 'actions'

const initialState = {
  loading: false,
  error: {
    login: false,
    noLoginMethodAvailable: false,
    sso: false,
    other: false,
  },
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGGING_IN: {
      return _.merge({}, state, {
        loading: true,
      })
    }
    case LOGIN_SUCCESSFUL: {
      return _.merge({}, state, {
        loading: false,
        error: {
          login: false,
          noLoginMethodAvailable: false,
          sso: false,
          other: false,
        },
      })
    }
    case LOGIN_FAILED: {
      const { login, noLoginMethodAvailable, sso, other } = action.error || { other: true }
      return _.merge({}, state, {
        loading: false,
        error: {
          login: !!login,
          noLoginMethodAvailable: !!noLoginMethodAvailable,
          sso: !!sso,
          other: !!other,
        },
      })
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/pages/login/index.js